function home_slider(slider) {
  var home_slider = $(slider);
  var slides = home_slider.find('.home_slider__slide');
  var previews_wrap = home_slider.next('.previews_wrap');
  var slider_previews = $('<div class="slider_previews"></div>');
  var autoplay_speed = 6000;
  var autoplay = true;

  // create slider preview
  slides.each(function(index, el) {
    var slide = $(el);
    slider_previews.append(html_slide_thumb({
      thumb: slide.data('thumb')
    }));
  });
  previews_wrap.append(slider_previews);

  // init main slider
  home_slider
    .on('init', function(slick) {

      // hide loader
      $('.lds-ellipsis').fadeOut(100);

      // apply slick to slider previews
      slider_previews.slick({
        rows: 0,
        speed: 400,
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: false,
        prevArrow: slick_prev('left-arrow2'),
        nextArrow: slick_next('right-arrow2'),
        asNavFor: '.home_slider',
        centerPadding: 0,
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [{
            breakpoint: 768,
            settings: {
              slidesToShow: 11,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 19,
              slidesToScroll: 1
            }
          }
        ]
      });

    })
    .slick({
      rows: 0,
      // dots: true,
      autoplay: autoplay,
      prevArrow: slick_prev('left-arrow2'),
      nextArrow: slick_next('right-arrow2'),
      autoplaySpeed: autoplay_speed,
      speed: 600,
      lazyLoad: 'progressive',
      asNavFor: '.slider_previews',
      cssEase: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
    })
    .on('beforeChange', function(event, slick, currentSlide, nextSlide) {

      var next_slide = slick.$slides.filter('.slick-current').next();
      var content_small = next_slide.find('.slider_content__small');
      var content_big = next_slide.find('.slider_content__big');
      var content_place = next_slide.find('.slider_content__bottom');

      TweenMax.from(content_small, 1.2, {
        x: '20%',
        opacity: 0,
        ease: Power2.easeOut
      });
      TweenMax.from(content_big, 1.3, {
        x: '20%',
        delay: 0.1,
        opacity: 0,
        ease: Power2.easeOut
      });
      TweenMax.from(content_place, 1.25, {
        x: '20%',
        delay: 0.2,
        opacity: 0,
        ease: Power2.easeOut
      });
    });

  adaptive_font_size('.slider_content__big');
  $(window).on('resize', function() {
    adaptive_font_size('.slider_content__big');
  });
}